import { useEffect, useState } from 'react'
import {
	fetchShoppingList,
	FetchShoppingListResponseData,
} from '../api/fetchShoppingList'
import { ShoppingListData } from '../store/shoppingListState'

export type FetchShoppingListState = {
	list: ShoppingListData
	loading: boolean
	error?: string
	data?: FetchShoppingListResponseData
}

export const useFetchShoppingList = (shoppingList: ShoppingListData) => {
	const [state, setState] = useState<FetchShoppingListState>(() => ({
		list: shoppingList,
		loading: true,
	}));

	useEffect(() => {
		setState({ ...state, loading: true })
		;(async () => {
			const result = await fetchShoppingList({
				variants: Object.keys(shoppingList.variants),
				counts: Object.values(shoppingList.variants),
				compositions: Object.keys(shoppingList.compositions),
			})
			if (!result.ok) {
				setState({ list: shoppingList, loading: false, error: result.error })
			} else {
				setState({ list: shoppingList, loading: false, data: result.data })
			}
		})()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [shoppingList])

	return state
}
